// extracted by mini-css-extract-plugin
export var avatarContainer = "_19-0";
export var avatarTypingWave = "_19-i";
export var gray = "_19-f";
export var green = "_19-c";
export var icon = "_19-9";
export var image = "_19-1";
export var lg = "_19-6";
export var md = "_19-5";
export var presenceDot = "_19-b";
export var red = "_19-d";
export var sm = "_19-4";
export var status = "_19-a";
export var typingDot = "_19-h";
export var typingPill = "_19-g";
export var xl = "_19-7";
export var xs = "_19-3";
export var xxl = "_19-8";
export var xxs = "_19-2";
export var yellow = "_19-e";